import { render, staticRenderFns } from "./myUpdates.vue?vue&type=template&id=543b977d&scoped=true&"
import script from "./myUpdates.vue?vue&type=script&lang=js&"
export * from "./myUpdates.vue?vue&type=script&lang=js&"
import style0 from "./myUpdates.vue?vue&type=style&index=0&id=543b977d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543b977d",
  null
  
)

export default component.exports